// schema

import moment from "moment-timezone";

import { maybeShowMinutes, prettyTimeRange } from "@clockwise/client-commons/src/util/date";
export { maybeShowMinutes, prettyTimeRange };

////////////////////////
// FORMATTING
///////////////////////
export function convertDateStringToMoment(dateString: string) {
  return moment.utc(dateString, "YYYY-MM-DD");
}
